import { Injectable } from "@angular/core";
import { NavigationExtras, Router } from "@angular/router";

import { StateMenu } from "../constants/sport-display";
import { UtilsService } from "../helpers/utils";
import { CompanyService } from "./company.service";
import { NavigationService, ParamsActions } from "./navigation.service";
import { LogService } from "~/core/services/log.service";

@Injectable({
  providedIn: "root",
})
export class RedirectService {
  constructor(
    private readonly companyService: CompanyService,
    private readonly navigation: NavigationService,
    private readonly router: Router,
  ) {}

  public openMatchType(state: StateMenu): void {
    switch (state) {
      case StateMenu.PRE_MATCH: {
        let mergeParams: NavigationExtras = {};
        if (UtilsService.isEnabledGuestPlayers(this.companyService) && window.location.href.includes(ParamsActions.GUEST_DEPOSIT)) {
          mergeParams = {
            queryParamsHandling: "merge",
          };
        }
        this.router.navigate([""], mergeParams);
        break;
      }
      case StateMenu.LIVE:
        UtilsService.scrollPos = 0;
        this.router.navigate(["live/s/SC"]);
        break;
      case StateMenu.CASINO:
        this.navigation.openCasino();
        break;
      case StateMenu.LIVE_CASINO:
        this.navigation.openLiveCasino();
        break;
      case StateMenu.MY_BETS:
        this.router.navigate(["user-dashboard", "my-bets"], { queryParams: { option: "MY-BETS_MAIN" } });
        break;
      case StateMenu.VIRTUAL_SPORTS:
        this.router.navigate(["virtual-sports"]);
        break;
      case StateMenu.E_SPORTS:
        this.router.navigate(["e-sports"]);
        break;
      case StateMenu.SPORTBOOK_WIREFRAME:
        this.router.navigate(["sportbook-wireframe"]);
        break;
      case StateMenu.STATISTICS:
        this.router.navigate(["statistics"]);
        break;
      case StateMenu.RESULTS:
        this.router.navigate(["results"]);
        break;
      default:
        LogService.log("Error: Default redirect to home!!!");
        this.router.navigate([""]);
    }
  }
}
